<template>
  <div
    class="rest-record-item tb"
    v-if="funcView.rest_record_list"
  >
    <custom-tab
      :value="type"
      :list="tabList"
      class="tab"
      @input="onTabChange"
    ></custom-tab>
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 导出excel -->
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.rest_record_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          :class="!funcView.rest_record_export ? 'mr-0' : ''"
        >
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.keyword"
            :placeholder="placeholder"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <el-radio-group
            v-model="selfPageType"
            @change="onPageTypeChange"
          >
            <el-radio-button
              :label="item.value"
              v-for="item in pageTypeData"
              :key="item.value"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item
          style="float: right"
          v-show="type === 2"
        >
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      v-show="type === 2"
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('fms_rest_record_item.jiao_yi_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.gmtCreate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        index
        :slots="['action']"
      >
        <template v-slot:action="scope">
          <span></span>
          <el-button
            type="text"
            size="mini"
            v-if="type === 2 && funcView.rest_record_use_detail && [13,19,11,14,21].includes(scope.row.balanceSource)"
            @click="useDetail(scope.row)"
            :billType="getBillType(scope.row)"
          >{{ $t('fms_rest_record_item.shi_yong_xiang_qing') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 收款详情 -->
    <accounts-collection-detail-dialog
      v-if="receiveDetailVisible"
      @close="receiveDetailVisible=false"
      :model="receiveDetailModel"
    ></accounts-collection-detail-dialog>
    <!-- 付款详情 -->
    <accounts-payable-detail-dialog
      v-if="payDetailVisible"
      @close="payDetailVisible=false"
      :model="payDetailModel"
    ></accounts-payable-detail-dialog>
    <!-- 退款详情 -->
    <refund-record-dialog
      v-if="refundDetailVisible"
      @close="refundDetailVisible=false"
      :model="refundDetailModel"
      :isReverse="true"
      :balanceType="2"
    ></refund-record-dialog>
  </div>
</template>

<script>
import qs from 'qs';
import moment from 'moment';
import apis from '@/utils/apis';
import accountsPayableDetailDialog from '@/pages/fms/components/accounts_payable_detail_dialog';
import accountsCollectionDetailDialog from '@/pages/fms/components/accounts_collection_detail_dialog';
import refundRecordDialog from '@/pages/fms/payRefund/children/refund_register_dialog.vue';

export default {
  name: 'restRecordItem',
  mixins: [],
  components: {
    accountsPayableDetailDialog,
    accountsCollectionDetailDialog,
    refundRecordDialog
  },
  props: {
    // 1 - 账户余额  2 - 使用历史
    type: Number,
    // 1 - 支出  2 - 收入
    pageType: Number,
    restData: {
      type: Object,
      default() {
        return {
          // 账户余额
          balanceAmount: 0,
          // 可用余额
          canUseAmount: 0,
          // 不可用金额
          lockAmount: 0,
        };
      }
    },
  },
  data() {
    return {
      link: null,
      selfPageType: 1,
      formSearch: {
        keyword: '',
        // 交易时间
        gmtCreate: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: null,
      receiveDetailVisible: false,
      receiveDetailModel: {},

      payDetailVisible: false,
      payDetailModel: {},

      refundDetailVisible: false,
      refundDetailModel: {},
      tableCode: '',
    };
  },
  computed: {
    pageTypeData() {
      return [
        {
          value: 1,
          label: this.$t('fms_rest_record_item.zhi_chu')
        },
        {
          value: 2,
          label: this.$t('fms_rest_record_item.shou_ru')
        }
      ];
    },
    tabList() {
      return [
        {
          name: this.$t('fms_rest_record_item.zhang_hu_yu_e'),
          value: 1
        },
        {
          name: this.$t('fms_rest_record_item.shi_yong_li_shi'),
          value: 2
        }
      ];
    },
    placeholder() {
      const map = [
        // 账户余额-支出
        {
          text: this.$t('fms_rest_record_item.shou_kuan_gong_si'),
          tabIndex: 1,
          typeIndex: 1,
        },
        // 账户余额-收入
        {
          text: this.$t('fms_rest_record_item.fu_kuan_gong_si'),
          tabIndex: 1,
          typeIndex: 2,
        },
        // 使用历史-支出
        {
          text: this.$t('fms_rest_record_item.shou_kuan_gong_si'),
          tabIndex: 2,
          typeIndex: 1,
        },
        // 使用历史-收入
        {
          text: this.$t('fms_rest_record_item.fu_kuan_gong_si'),
          tabIndex: 2,
          typeIndex: 2,
        }
      ];
      const item = map.find(obj => obj.tabIndex === this.type && obj.typeIndex === this.selfPageType);
      return item ? item.text : '';
    }
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    updateTableCode() {
      const tableCodeMap = [
        // 账户余额-支出
        {
          tableCode: 'account_rest_pay',
          tabIndex: 1,
          typeIndex: 1,
        },
        // 账户余额-收入
        {
          tableCode: 'account_rest_receive',
          tabIndex: 1,
          typeIndex: 2,
        },
        // 使用历史-支出
        {
          tableCode: 'rest_use_history_pay',
          tabIndex: 2,
          typeIndex: 1,
        },
        // 使用历史-收入
        {
          tableCode: 'rest_use_history_receive',
          tabIndex: 2,
          typeIndex: 2,
        }
      ];
      const item = tableCodeMap.find(obj => obj.tabIndex === this.type && obj.typeIndex === this.selfPageType);
      const tableCode = item ? item.tableCode : '';
      this.tableCode = tableCode;

      this.getTableColumn();
    },
    // 获取数据的类型
    // receive - 收款  pay - 付款  refund - 退款
    getBillType(row) {
      const balanceSource = `${row.balanceSource}`;

      // 13-账单退款,19-押金转入：退款详情
      const refundStatus = ['13', '19'];

      if (refundStatus.includes(balanceSource)) {
        return 'refund';
      }

      // balanceSource
      // 11-支付结余，14-收款撤销，21-支付账单
      // 本组织是付款组织时，显示付款详情
      // 本组织是收款组织时，显示收款详情

      return this.isReceivableOrg(row.receivableOrgId) ? 'receive' : 'pay';
    },
    useDetail(row) {
      // 判断是什么类型的数据
      const type = this.getBillType(row);
      // 调用对应的显示方法
      switch (type) {
        case 'receive':
          this.showReceiveDetail(row);
          break;
        case 'pay':
          this.showPayDetail(row);
          break;
        case 'refund':
          this.showRefundDetail(row);
          break;
      }

    },
    // 显示收款详情
    showReceiveDetail(row) {
      this.receiveDetailModel = {
        title: this.$t('fms_rest_record_item.shou_kuan_xiang_qing'),
        data: {
          billData: [row]
        }
      };
      this.receiveDetailVisible = true;
    },
    // 显示付款详情
    showPayDetail(row) {
      this.payDetailModel = {
        title: this.$t('fms_rest_record_item.fu_kuan_xiang_qing'),
        data: {
          billData: [row]
        }
      };
      this.payDetailVisible = true;
    },
    // 显示退款详情
    showRefundDetail(row) {
      this.refundDetailModel = {
        title: this.$t('fms_rest_record_item.tui_kuan_xiang_qing'),
        row,
        type: 'watch'
      };
      this.refundDetailVisible = true;
    },
    onTabChange(value) {
      this.$emit('tab', value);
      this.$emit('pageTypeChange', 1);
    },
    onPageTypeChange(value) {
      this.$emit('pageTypeChange', value);
    },
    async exportTable() {
      const reqListData = this.getReqListData();
      const param = {};
      Object.keys(reqListData).forEach((key) => {
        const val = reqListData[key];
        if (![undefined, '', null].includes(val)) {
          param[key] = val;
        }
      });

      delete param.pageSize;
      delete param.pageNum;

      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });

      const headerList = [...this.tableColumn];

      const date = new Date();
      const fileName = this.$t('fms_rest_record_item.yu_e_ji_lu');
      const exportName = `${fileName}_${moment(date).format('YYYYMMDDHHmmss')}`;

      const reqData = {
        exportName: exportName,
        headerList: headerList,
      };

      this.$showLoading();
      try {
        const url = this.type === 1 ? apis.partnerBalanceAccountBalanceExport : apis.partnerBalanceRecordExport;
        await this.$exportFliePost(`${url}?${pathParms}`, reqData);
      } catch (e) {
        this.$message.error(e.message || e.msg || this.$t('fms_rest_record_item.dao_chu_shi_bai'));
      }
      this.$closeLoading();
    },
    getTableList() {
      const url = this.type === 1 ? apis.partnerBalanceAccountBalancePage : apis.partnerBalanceRecordPage;
      const reqData = this.getReqListData();
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getReqListData() {
      // const userId = this.$store.state.userInfo.rootOrgId;
      // const type = this.type;
      const pageType = this.selfPageType;

      const ret = {
        ...this.formSearch
      };

      const incomeMap = {
        // 收入
        in: true,
        // 支出
        out: false
      };

      // 账户余额
      // if (type === 1) {
      //   ret.payableOrgId = userId;
      // } else {
      //   // 使用历史
      //   ret.receivableOrgId = userId;
      // }

      // 支出
      if (pageType === 1) {
        ret.receivableOrgName = ret.keyword;
      } else {
        // 收入
        ret.payableOrgName = ret.keyword;
      }

      ret.incomeOrOut = pageType === 1 ? incomeMap.out : incomeMap.in;

      return ret;
    },
    // 清除
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
  },
  created() {
  },
  mounted() {
    this.selfPageType = this.pageType;
    this.updateTableCode();
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getTableList();
  },
};
</script>

<style lang="scss">
.rest-record-item {
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }

  .half-content {
    width: 25%;
    display: inline-block;
  }

  .half-width {
    width: 50% !important;
  }

  .underline {
    color: #0d9ae0;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
